import React, { Component } from 'react'
import { isSafari } from 'react-device-detect'
import './Audio.scss'
import { AudioPlayer } from '../../../../../views/Courses/Create/nestedComponents/PageBuilder/Components/Audio/components'

export default class extends Component {
  render() {
    const {
      elementHeight,
      elementWidth,
      node,
      node: { params },
      autoPlay = false
    } = this.props

    // Define the minimum width and height based on the condition
    const minWidth = node.type === 'AUDIO' ? (isSafari ? 150 : 70) : 30
    const minHeight = node.type === 'AUDIO' ? (isSafari ? 140 : 70) : 30

    // Ensure width and height are at least the minimum values
    const width =
      elementWidth < minWidth || elementHeight < minHeight
        ? 70
        : Math.max(elementWidth || params.width, minWidth)
    const height =
      elementHeight < minHeight || elementWidth < minWidth
        ? 70
        : Math.max(elementHeight || params.height, minHeight)

    return (
      <AudioPlayer
        width={70}
        height={70}
        src={params.content}
        isCourse
        autoPlay={autoPlay}
      />
    )
  }
}
